import React, { ChangeEvent, useRef, useState } from "react";
import CustomModal from "../../../../components/CustomModal";
import { ModalWrapper } from "../../../../components/WelcomeToFipayModal/WelcomeModal";
import {
  OtpFormContainer,
  OtpInput,
  OtpInputContainer,
  ResendCodeContainer,
  ResendCodeText,
} from "../../../Otp/otp.styles";
import { styled } from "styled-components";
import { colors } from "../../../../theme/color";
import { setUserData } from "../../../../store/user";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";

interface ReassignRoleOtpModalProps {
  onClose: () => void;
  onSubmit: () => void;
}

const ReassignRoleOtpModal: React.FC<ReassignRoleOtpModalProps> = ({
  onClose,
  onSubmit,
}) => {
  const [open, setOpen] = useState(true);
  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
  const [showModalWrapper, setShowModalWrapper] = useState(true);
  const otpInputs = useRef<HTMLInputElement[]>([]);
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user?.user);
  const { currentRole, selectedRole } = useSelector(
    (state: RootState) => state.userManagement
  );
  const currentRoleLower = currentRole?.toLowerCase();
  const selectedRoleLower = selectedRole?.toLowerCase();

  const handleOtpChange = (index: number, value: string) => {
    const newValue = value.charAt(0);
    const updatedOtpValues = [...otpValues];
    updatedOtpValues[index] = newValue;
    setOtpValues(updatedOtpValues);
    dispatch(setUserData({ ...user, otp: updatedOtpValues }));

    if (newValue && index < otpInputs.current.length - 1) {
      otpInputs.current[index + 1].focus();
    } else if (!newValue && index > 0) {
      otpInputs.current[index - 1].focus();
    }
  };

  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Backspace" && index > 0 && !otpValues[index]) {
      event.preventDefault();
      const updatedOtpValues = [...otpValues];
      updatedOtpValues[index - 1] = "";
      setOtpValues(updatedOtpValues);
      otpInputs.current[index - 1].focus();
    }
  };

  const handleClose = () => {
    setOpen(false);
    setShowModalWrapper(false);
    onClose();
  };

  const handleSubmit = () => {
    setOpen(false);
    onSubmit();
  };

  return (
    <>
      <CustomModal
        open={open}
        onClose={handleClose}
        header={
          selectedRole !== "Administrator" && selectedRole !== "multiple"
            ? ""
            : {
                title: `Reassign ${selectedRole === "multiple" ? "Mulitiple User" : ""} Role`,
                subtitle: "Enter the 6-digit code sent to your email address ",
              }
        }
        closeActionText={
          selectedRole !== "Administrator" &&
          selectedRole !== "multiple" &&
          "No, Cancel"
        }
        submitActionText={
          selectedRole === "Administrator" || selectedRole === "multiple"
            ? "Reassign"
            : "Yes, Reassign"
        }
        onSubmit={handleSubmit}
        btn1Bg="transparent"
        btn1Border={`1px solid ${colors.DARK_GRAY}`}
        btn1Color={colors.DARK_GRAY}
        btn2Bg={colors.GREEN}
        btn2Border={`1px solid ${colors.GREEN}`}
        btn2Color={colors.White}
        btnPadding="10px 24px"
        btnBorderRadius="10px"
      >
        {selectedRole === "Administrator" || selectedRole === "multiple" ? (
          <>
            <OtpFormContainer>
              <OtpInputContainer className="otpInput">
                {otpValues.map((value, index) => (
                  <OtpInput
                    key={index}
                    value={value}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      handleOtpChange(index, e.target.value)
                    }
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
                      handleKeyDown(index, e)
                    }
                    type="text"
                    maxLength={1}
                    ref={(ref) => {
                      if (ref) {
                        otpInputs.current[index] = ref;
                      }
                    }}
                  />
                ))}
              </OtpInputContainer>
            </OtpFormContainer>

            <ResendCodeContainer>
              <ResendCodeText onClick={() => {}}>Resend code</ResendCodeText>
            </ResendCodeContainer>
          </>
        ) : (
          <NonHeaderModal>
            <strong>Reassign {currentRoleLower}</strong>
            <span>
              {` Are you sure you want to reassign this ${currentRoleLower} to a
                  ${selectedRoleLower?.split(" ")[0]} `}
              <br /> user?
            </span>
          </NonHeaderModal>
        )}
      </CustomModal>
    </>
  );
};

export default ReassignRoleOtpModal;

export const NonHeaderModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  strong {
    color: #0e0e0e;
    font-size: 1.5rem;
    font-weight: 700;
  }

  span {
    text-align: center;
    color: #8c8b8b;
    font-size: 1rem;
    font-weight: 400;
  }
`;
